import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

import { handleTagRedirect } from './utils';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'topic',
		path: '/topic/:slug',
		beforeServerRender: handleTagRedirect,
		component: loadable(async () => import(/* webpackChunkName: "pages/topic" */ './index'), {
			exportName: 'Topic',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
